import { render, staticRenderFns } from "./EvenementsVignetteIcon.vue?vue&type=template&id=6fa5651a"
import script from "./EvenementsVignetteIcon.vue?vue&type=script&lang=js"
export * from "./EvenementsVignetteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports